// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"fe3a5945","488":"939e33b1","777":"d6af9330"}[chunkId] + ".chunk.js";
};